<script>
  import { createEventDispatcher } from "svelte"
  import StorageUnitRowPanelStorageUnitList from "./StorageUnitRowPanelStorageUnitList.svelte"

  export let storageUnitRow

  const dispatch = createEventDispatcher()

  function handleDeleteClick() {
    dispatch("deletestorageunitrow", { storageUnitRowId: storageUnitRow.id })
  }

  function handleAlignButtonClick(e) {
    const align = e.currentTarget.getAttribute("data-value")

    storageUnitRow.align = align

    dispatch("savestorageunitrow", {
      align,
      storageUnitRowId: storageUnitRow.id,
    })
  }

  function handleSave() {
    let x = document.getElementById("storageUnitRowPositionXInput").value
    let y = document.getElementById("storageUnitRowPositionYInput").value
    x = x.replaceAll(/[^\.]/g, "").length > 1 ? [x.split(".")[0], x.split(".")[1]].join(".") : x

    y = y.replaceAll(/[^\.]/g, "").length > 1 ? [y.split(".")[0], y.split(".")[1]].join(".") : y

    document.getElementById("storageUnitRowPositionXInput").value = x
    document.getElementById("storageUnitRowPositionYInput").value = y

    dispatch("savestorageunitrow", {
      align: storageUnitRow.align,
      storageUnitRowId: storageUnitRow.id,
      position: { x, y },
      rotation: document.getElementById("storage_unit_type_site_map_name_rotation").value,
    })
  }

  function rotate90() {
    const val = storageUnitRow.rotation
    let newSnap = 0
    if (val < 90) {
      newSnap = 90
    } else if (val < 180) {
      newSnap = 180
    } else if (val < 270) {
      newSnap = 270
    } else {
      newSnap = 0
    }

    updateRotation(newSnap)
  }

  function updateRotation(rotation) {
    storageUnitRow.rotation = rotation

    dispatch("savestorageunitrow", {
      storageUnitRowId: storageUnitRow.id,
      rotation,
    })
  }

  let submitButton = document.querySelector("[type=submit]")
  let buttonClasses = ""
  if (submitButton) {
    buttonClasses = [...submitButton.classList, "w-full"]
      .filter((c) => c !== "sm:w-auto")
      .join(" ")
  }

  let secondaryButton = document.querySelector("#back_link")
  let secondaryButtonClasses = ""
  if (submitButton) {
    secondaryButtonClasses = [...secondaryButton.classList, "w-full"]
      .filter((c) => c !== "sm:w-auto")
      .join(" ")
  }

  function updatePosition(e) {
    let position = {
      x: storageUnitRow.position.x,
      y: storageUnitRow.position.y,
    }
    if (e.currentTarget.id === "storageUnitRowPositionXInput") {
      position.x = Number(e.currentTarget.value)
    } else if (e.currentTarget.id === "storageUnitRowPositionYInput") {
      position.y = Number(e.currentTarget.value)
    }

    dispatch("savestorageunitrow", {
      storageUnitRowId: storageUnitRow.id,
      position,
      rotation: storageUnitRow.rotation,
    })
  }

  function arrowPress(e) {
    const offset = e.shiftKey ? 10.0 : 1.0
    let n = Number(e.currentTarget.value)
    n = Number.isNaN(n) ? 0 : n
    if (e.key === "ArrowUp") {
      e.preventDefault()
      e.currentTarget.value = (n + offset).toFixed(2)
      updatePosition(e)
    }
    if (e.key === "ArrowDown") {
      e.preventDefault()
      e.currentTarget.value = (n - offset).toFixed(2)
      updatePosition(e)
    }
  }

  $: isEndAlign = storageUnitRow.align == "end"
  $: isStartAlign = storageUnitRow.align == "start"
</script>

<div class="border bg-white rounded-xl shadow font-display">
  <form on:submit|preventDefault={handleSave}>
    <div class="p-2 px-4">
      <div class="py-2">
        <label
          class="font-display text-sm font-medium text-gray-700"
          for="storageUnitRowPositionXInput">X</label
        >
        <input
          type="number"
          required
          inputmode="decimal"
          on:keydown={arrowPress}
          step="0.01"
          id="storageUnitRowPositionXInput"
          class="w-full border-gray-300 rounded-md font-display px-3 py-2 placeholder-gray-400 sm:text-sm"
          value={storageUnitRow.position.x.toFixed(2)}
        />
      </div>
      <div class="py-2">
        <label
          class="font-display text-sm font-medium text-gray-700"
          for="storageUnitRowPositionYInput">Y</label
        >
        <input
          type="number"
          step="0.01"
          required
          on:keydown={arrowPress}
          id="storageUnitRowPositionYInput"
          inputmode="decimal"
          class="w-full border-gray-300 rounded-md font-display px-3 py-2 placeholder-gray-400 sm:text-sm"
          value={storageUnitRow.position.y.toFixed(2)}
        />
      </div>

      <div class="my-2">
        <label
          class="font-display text-sm font-medium text-gray-700"
          for="storage_unit_type_site_map_name_rotation">Rotationº</label
        >
        <div class="flex items-center gap-2">
          <input
            min="0"
            max="360"
            data-range-rotate-target="range"
            data-controller="range"
            data-action="range#updateProgress"
            class="w-full rounded-md font-display placeholder-gray-400 sm:text-smtext-black focus:border-black focus:outline-none focus:ring-black border-gray-300 bg-gray-50 text-gray-900 disabled:bg-gray-200 disabled:text-gray-500 disabled:cursor-not-allowed"
            type="range"
            aria-hidden="true"
            on:input={(e) => {
              updateRotation(e.target.value)
            }}
            value={storageUnitRow.rotation}
            name="storage_unit_type[site_map_name_rotation]"
            id="storage_unit_type_site_map_name_rotation"
          />
          <button
            type="button"
            on:click={rotate90}
            class="bg-white hover:bg-gray-100 rounded-xl border p-2 text-slate-700"
          >
            <svg
              aria-hidden="true"
              class="h-5 text-black w-6"
              fill="currentColor"
              id="arrow-path-rounded-square"
              stroke-width="1.5"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M12 5.25c1.213 0 2.415.046 3.605.135a3.256 3.256 0 013.01 3.01c.044.583.077 1.17.1 1.759L17.03 8.47a.75.75 0 10-1.06 1.06l3 3a.75.75 0 001.06 0l3-3a.75.75 0 00-1.06-1.06l-1.752 1.751c-.023-.65-.06-1.296-.108-1.939a4.756 4.756 0 00-4.392-4.392 49.422 49.422 0 00-7.436 0A4.756 4.756 0 003.89 8.282c-.017.224-.033.447-.046.672a.75.75 0 101.497.092c.013-.217.028-.434.044-.651a3.256 3.256 0 013.01-3.01c1.19-.09 2.392-.135 3.605-.135zm-6.97 6.22a.75.75 0 00-1.06 0l-3 3a.75.75 0 101.06 1.06l1.752-1.751c.023.65.06 1.296.108 1.939a4.756 4.756 0 004.392 4.392 49.413 49.413 0 007.436 0 4.756 4.756 0 004.392-4.392c.017-.223.032-.447.046-.672a.75.75 0 00-1.497-.092c-.013.217-.028.434-.044.651a3.256 3.256 0 01-3.01 3.01 47.953 47.953 0 01-7.21 0 3.256 3.256 0 01-3.01-3.01 47.759 47.759 0 01-.1-1.759L6.97 15.53a.75.75 0 001.06-1.06l-3-3z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
        <div class="font-display text-sm text-gray-500 mt-1">
          <span>{storageUnitRow.rotation}</span>º
        </div>
      </div>

      <div class="flex items-center justify-between pb-4">
        <label class="text-sm font-medium text-gray-700" for="storageUnitRowAlign">Align: </label>

        <div class="flex gap-4 items-center">
          <button
            class="hover:bg-gray-100 rounded-xl border p-2 text-black"
            class:bg-gray-200={isStartAlign}
            class:bg-white={!isStartAlign}
            class:border-slate-400={isStartAlign}
            data-value="start"
            on:click={handleAlignButtonClick}
            type="button"
          >
            <svg
              aria-hidden="true"
              class="h-5 w-5"
              fill="currentColor"
              id="bars-3-bottom-left"
              stroke-width="2.0"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75H12a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          <button
            class="hover:bg-gray-100 rounded-xl border p-2 text-black"
            class:bg-gray-200={isEndAlign}
            class:bg-white={!isEndAlign}
            class:border-slate-400={isEndAlign}
            data-value="end"
            on:click={handleAlignButtonClick}
            type="button"
          >
            <svg
              aria-hidden="true"
              class="h-5 w-5"
              fill="black"
              id="bars-3-bottom-right"
              stroke-width="2.0"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clip-rule="evenodd"
                d="M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm8.25 5.25a.75.75 0 01.75-.75h8.25a.75.75 0 010 1.5H12a.75.75 0 01-.75-.75z"
                fill-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>

      <button class={buttonClasses} title="Ctrl+s" type="submit">Save</button>

      <div class="my-4">
        <button class={secondaryButtonClasses} on:click={handleDeleteClick}>
          Delete Row
        </button>
      </div>
    </div>
  </form>

  <StorageUnitRowPanelStorageUnitList
    storageUnits={storageUnitRow.storageUnits}
    on:reorderstorageunits={(e) =>
      dispatch("reorderstorageunits", {
        storageUnitRowId: storageUnitRow.id,
        storageUnitIds: e.detail.storageUnitIds,
      })}
  />
</div>
